import { axios } from '@/utils/request'

const api = {
  operationLog: '/log/operation',
  loginLog: '/loginLog/log',
  SearchCUserLoginLog: '/loginLog/cuserLoginLog'
}

export default api

export function getOperationLog(params) {
  return axios({
    url: api.operationLog,
    method: 'get',
    params
  })
}

export function getLoginLog(params) {
  return axios({
    url: api.loginLog,
    method: 'get',
    params
  })
}

export function searchCUserLoginLog(params) {
  return axios({
    url: api.SearchCUserLoginLog,
    method: 'get',
    params
  })
}
